<template>
  <div class="hbb_productBox">
    <div
      class="hbb_productGroup"
      v-for="(item, index) in validCategorys"
      :key="index"
      v-show="isCreated"
    >
      <h2>
        {{ item.categoryGroupName }}
        <div class="sdw-fold" @click="onSwitchCategory(item)">
          <span
            class="icon"
            :class="item.isDisplaying ? 'icon-up' : 'icon-down'"
          />
          <span class="text">{{ item.isDisplaying ? "收起" : "展开" }}</span>
        </div>
        <div class="sdw-loading" v-loading="item.loading"></div>
      </h2>
      <template v-if="item.isDisplaying">
        <div class="noFitPart" v-if="item.categroys.length == 0">
          该车暂无此配件
        </div>
        <ul v-else>
          <li v-for="(ite, ind) in item.categroys" :key="ind">
            <div class="titleBox">
              <span class="one">{{ ite.partsName }}</span>
              <span class="two" v-if="ite.dosageDesc" :title="ite.dosageDesc">{{
                ite.dosageDesc
              }}</span>
            </div>
            <div class="partsBox">
              <div
                class="hbb_partItemBox"
                v-for="itd in ite.oemDosageList"
                :key="itd"
              >
                <div class="descBox" v-if="itd.oemDesc">
                  <span class="sdw_oem_mark"></span>
                  <span class="sdw_oem_desc">{{ itd.oemDesc }}</span>
                  <span
                    class="sdw_oem_image"
                    v-if="itd.images.length > 0"
                    @click="on_oemImage_click(itd.images)"
                  ></span>
                </div>
                <div
                  v-for="it in itd.partItems"
                  :class="it.isSelect ? 'textBox textBoxActive' : 'textBox'"
                  :key="it"
                  @dblclick="on_partitem_dblclick($event, it)"
                  @click.stop="on_partitem_click(it)"
                  :data-brandid="it.brandId"
                >
                  <!-- 无适配 -->
                  <span v-if="it.partItemKind == 2" class="hbb_text hbb_textNo"
                    >{{ it.brandName }} {{ it.displayPartsNo }}</span
                  >

                  <!-- 超级目录产品 -->
                  <span v-else class="hbb_text hbb_textYes"
                    >{{ it.brandName }} {{ it.displayPartsNo }}</span
                  >

                  <!-- 有产品则展示详情 -->
                  <div class="tag-copy" v-if="it.partItemId > 0">详情</div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </template>
    </div>

    <!-- 查看变速箱油接口图 -->
    <el-dialog
      title="变速箱油接口图"
      :visible.sync="mySwiperState"
      width="30%"
      :before-close="handleClose"
    >
      <MySwiper></MySwiper>
    </el-dialog>
    <!-- 当前商品的详细信息 -->
    <el-dialog
      title="商品详情"
      :visible.sync="partItemDialog"
      width="30%"
      class="hbb-paritem"
      :before-close="handleClose"
    >
      <PartItemDetail
        v-if="partItemDialog"
        ref="partItemDetail"
      ></PartItemDetail>
    </el-dialog>

    <!-- 查看大图 -->
    <ZhipeiViewer
      v-if="ZhipeiViewer_launched"
      :on-close="on_ZhipeiViewer_close"
      :url-list="ZhipeiViewer_images"
    />
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import Clipboard from "clipboard";
import MySwiper from "@components/MySwiper/Index";
import PartItemDetail from "@components/PartItemDetail/Index";
import ZhipeiViewer from "@components/ZhipeiViewer/image-viewer";
export default {
  components: {
    MySwiper,
    PartItemDetail,
    ZhipeiViewer,
  },
  data() {
    return {
      mySwiperState: false, // 查看变速箱油接口图 弹框是否启动
      partItemDialog: false, // 查看当前商品的详细信息 弹框是否启动
      validCategorys: [], // 获取所有的品类集合 【用于轮询请求产品数据】
      CategoryIds: [], // 存放当前品类组的集合
      CategoryGroupId: 0, // 当前请求品类组id
      vinCode: "", // 当前车型的vin码
      isLoading: false, // 是否全部加载完毕
      ZhipeiViewer_launched: false, //大图组件是否已启动
      ZhipeiViewer_images: [], //大图组件的图片集合
      click_dblclick_conflict_timer: null, //  单击双击冲突计时器
      currentBrands: [], //可选品牌集合
    };
  },
  watch: {
    validCategorys: function () {
      this.isLoading = false;
      this.$nextTick(() => {
        this.isLoading = true;
      });
    },
  },
  computed: {
    ...mapGetters({
      isCreated: "CommonModule/getViewModalOver",
    }),
  },
  mounted() {
    let _this = this;

    _this.init();
  },
  updated() {},
  methods: {
    ...mapMutations({
      setViewModalOver: "CommonModule/SET_VIEWMODALOVER",
    }),
    ...mapActions({
      GetCjmlAutoValidPartAndParam:
        "SearchResultModule/GetCjmlAutoValidPartAndParam",
    }),

    //切换品类展示
    onSwitchCategory(oneCategory) {
      this.categoryGroupId = oneCategory.categoryGroupId;
      if (oneCategory.isDisplaying) {
        oneCategory.isDisplaying = false;
        this.resetCurrentBrands(); // 重置有效品牌
        this.$emit("lastOverEvent");
        return;
      }
      if (oneCategory.waitFill == false) {
        //已经补充过, 则直接展示
        this.validCategorys.forEach((x, i) => {
          if (x.categoryGroupId == oneCategory.categoryGroupId) {
            x.isDisplaying = true; //设置为展示
            this.resetCurrentBrands(); // 重置有效品牌
            this.$emit("lastOverEvent");
          } else {
            // x.isDisplaying = false; //其他品类隐藏
          }
        });
      } else {
        //未补充过, 则调用接口再展示
        oneCategory.loading = true;
        this.GetCjmlAutoValidPartAndParam({
          categoryGroupId: this.categoryGroupId,
          vinCode: this.vinCode,
          categoryIds: oneCategory.categroys.map((x) => {
            return x.categoryId;
          }),
        })
          .then((res) => {
            oneCategory.loading = false;
            this.validCategorys.forEach((x, i) => {
              if (x.categoryGroupId == res.categoryGroupId) {
                x.waitFill = false; //设置为已完善
                x.isDisplaying = true; //设置为展示
                x.categroys = res.partsList;
                this.resetCurrentBrands(); // 重置有效品牌
              } else {
                // x.isDisplaying = false; //其他品类隐藏
              }
            });
            this.$emit("lastOverEvent");
          })
          .catch((err) => {
            oneCategory.loading = false;
          });
      }
    },

    // 取得品类完整数据
    // responeData: 请求的品类信息
    // index: 当前品类在全体品类集合里的index
    GetCjmlAutoValid(responeData, index) {
      // 通过品类组下面的品类的id集合 去获取对应的品类下面的配件
      let _this = this;

      //只展示前N个品类
      if (index > 0) {
        this.$emit("lastOverEvent");
        return;
      }

      this.categoryGroupId = responeData.categoryGroupId;
      let request_data = {
        categoryGroupId: _this.categoryGroupId,
        vinCode: _this.vinCode,
        categoryIds: responeData.categroys.map((x) => {
          return x.categoryId;
        }),
      };

      this.$nextTick(() => {
        _this
          .GetCjmlAutoValidPartAndParam(request_data)
          .then((res) => {
            // console.log("返回配件", res);
            this.validCategorys.forEach((x, i) => {
              if (x.categoryGroupId == res.categoryGroupId) {
                x.waitFill = false; //设置为已完善
                x.isDisplaying = true; //设置为展示
                x.categroys = res.partsList;
                this.resetCurrentBrands(); // 重置有效品牌
              } else {
                x.isDisplaying = false; //其他品类隐藏
              }
            });
            let currentNext = {};
            let currentIndex = this.validCategorys.indexOf(responeData);
            let nextObjIndex = currentIndex + 1;
            if (nextObjIndex < this.validCategorys.length) {
              currentNext = this.validCategorys[nextObjIndex];
              _this.$emit(
                "GetCjmlAutoValidPartSuccess",
                currentNext,
                nextObjIndex
              );
            } else {
              _this.$nextTick(() => {
                _this.getParentHeight();
              });
              _this.$emit("lastOverEvent");
              return false;
            }
          })
          .catch((err) => {
            this.setViewModalOver(true);
          });
      });
    },
    // 清空有效品牌
    clearCurrentBrands() {
      this.currentBrands = [];
    },
    // 重置有效品牌
    resetCurrentBrands() {
      this.currentBrands = [];
      this.validCategorys.forEach((o) => {
        if (o.isDisplaying == false) return;
        o.categroys.forEach((y) => {
          y.oemDosageList.forEach((z) => {
            z.partItems.forEach((k) => {
              k.isSelect = false;
              if (k && k.brandId) {
                this.currentBrands.push(k.brandId);
              }
            });
          });
        });
      });
    },
    // 取得有效品牌
    getCurrentBrands() {
      return [...new Set(this.currentBrands)];
    },
    init() {
      // 初始化
      let _this = this;

      // 处理文本
    },
    handleText() {
      // / 处理文本
      let obj = $(".hbb_text");
      let maxNum = 20;
      obj.each(function () {
        let everyText = $(this).text();
        if (everyText.length >= maxNum) {
          let delStr = $(this)
            .text()
            .substring(maxNum - 1, everyText.length);
          let str = everyText.replace(delStr, "...");
          $(this).text(str);
        }
      });
      let textdivWidth = $(".hbb_text").width();
      let textdivHeight = $(".hbb_text").height();
      $(".tag-copy").css({ width: textdivWidth + "px" });
    },
    getParentHeight() {
      // 取得存放内容div的高度  自适应  第一次
      let _this = this;
      let divOffsetTop = $(".hbb_productBox").offset().top;
      let windowHeight = $(window).height();
      let divHeight = windowHeight - divOffsetTop - 40;
      $(".hbb_productBox").css({ height: divHeight + "px" });
    },
    //查看OE图片
    on_oemImage_click(images) {
      if (images.length == 0) return;
      this.ZhipeiViewer_launched = true;
      this.ZhipeiViewer_images = images;
    },
    // 大图组件关闭
    on_ZhipeiViewer_close() {
      this.ZhipeiViewer_launched = false;
    },
    on_partitem_dblclick(e, text) {
      clearTimeout(this.click_dblclick_conflict_timer); //清除单击双击冲突计时器

      // 点击复制文本
      if (!text.partItemId) return;
      const clipboard = new Clipboard(e.target, {
        text: () => text.displayPartsNo,
      });
      clipboard.on("success", (e) => {
        this.$message({ type: "success", message: "复制成功" });
        // 释放内存
        clipboard.off("error");
        clipboard.off("success");
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        this.$message({ type: "waning", message: "该浏览器不支持自动复制" });
        // 释放内存
        clipboard.off("error");
        clipboard.off("success");
        clipboard.destroy();
      });
      clipboard.onClick(e);
    },
    on_partitem_click(item) {
      let _this = this;
      clearTimeout(this.click_dblclick_conflict_timer); //首先清除单击双击冲突计时器
      this.click_dblclick_conflict_timer = setTimeout(() => {
        // 取得商品详情
        if (item.partItemId <= 0) return;
        _this.partItemDialog = true;
        setTimeout(() => {
          _this.$refs.partItemDetail.startup(item.partItemId);
        }, 0);
      }, 300); //大概时间300ms
    },
    lookMySwiper() {
      // 查看变速箱油接口图
      this.mySwiperState = true;
    },
    scrollTopFn() {
      //每次点击切换VIN码记录重置scrollTop
      $(".hbb_productBox").animate({ scrollTop: "0px" }, 800);
    },
    productPosition(id, isNeedScroll) {
      // 点击品牌定位的、指定商品console.log()
      if (!this.isLoading) {
        setTimeout(() => {
          this.productPosition(id, isNeedScroll);
        }, 500);
      } else {
        if (!isNeedScroll) return false;
        $(".hbb_productBox").animate({ scrollTop: "0" }, 0);
        let fristTopVal = $(".textBox[data-brandid='" + id + "']").position()
          .top;
        $(".hbb_productBox").animate({ scrollTop: fristTopVal + "px" }, 800);
      }
    },
  },
};
</script>

<style>
@import "../../../assets/css/brankproduct.css";
[v-cloak] {
  display: none;
}
</style>